import { Commit } from 'vuex';
import { ToastMessage } from '@/interfaces/alerts';
import Vue from 'vue';

interface MessageHandling {
	messages: {
		[id: string]: ToastMessage;
	};
}

export default {
	namespaced: true,
	state: {
		messages: {},
	} as MessageHandling,

	getters: {
		getMessages: (state: MessageHandling): ToastMessage[] => {
			return Object.values(state.messages);
		},
		getMessage:
			(state: MessageHandling) =>
			(id: number): ToastMessage => {
				return state.messages[id];
			},
	},

	mutations: {
		ADD_MESSAGE(state: MessageHandling, error: ToastMessage): void {
			Vue.set(state.messages, error.id, error);
		},

		REMOVE_MESSAGE(state: MessageHandling, id: number): void {
			Vue.delete(state.messages, id);
		},

		CLEAN_MESSAGES(state: MessageHandling): void {
			state.messages = {};
		},
	},

	actions: {
		addMessage(
			{ commit }: { commit: Commit },
			{ id, message, type, delay }: { id: string; message: string; type: string; delay: number }
		): void {
			commit('ADD_MESSAGE', { id: id, message: message, variant: type, delay: delay });
		},

		addErrorMessage(
			{ commit }: { commit: Commit },
			{ id, message }: { id: string; message: string }
		): void {
			commit('ADD_MESSAGE', { id: id, message: message, variant: 'danger', delay: 60000 });
		},

		removeMessage({ commit }: { commit: Commit }, id: string): void {
			commit('REMOVE_MESSAGE', id);
		},

		cleanMessages({ commit }: { commit: Commit }): void {
			commit('CLEAN_MESSAGES');
		},
	},
};
